import React from 'react';
import { Button } from "@focusdive/ui";
import { Play, Pause, RotateCcw, Coffee, Brain } from 'lucide-react';
import { useTimer } from '@focusdive/timer';
import { startTimer, pauseTimer, resetTimer, setTimerMode } from '@focusdive/timer';

export const TimerControls: React.FC = () => {
  const { mode, isRunning } = useTimer()
  const onToggleTimer = () => {
    if (!isRunning) {
      startTimer();
    } else {
      pauseTimer();
    }
  }
  const onToggleMode = () => {
    setTimerMode(mode === 'focus' ? 'break' : 'focus');
  }

  return (
    <>
      <Button 
        onClick={onToggleTimer}
        size="lg" 
        className="flex-1 py-6 text-lg"
        variant="default"
      >
        {isRunning ? (
          <>
            <Pause className="mr-2" /> Pause
          </>
        ) : (
          <>
            <Play className="mr-2" /> Start
          </>
        )}
      </Button>
      
      <Button 
        onClick={resetTimer} 
        size="lg"
        className="flex-1 py-6 text-lg"
        variant="outline"
      >
        <RotateCcw className="mr-2" /> Reset
      </Button>
      
      <Button 
        onClick={onToggleMode} 
        size="lg"
        className="flex-1 py-6 text-lg"
        variant={mode === 'focus' ? "secondary" : "default"}
      >
        {mode === 'focus' ? (
          <>
            <Coffee className="mr-2" /> Switch to Break
          </>
        ) : (
          <>
            <Brain className="mr-2" /> Switch to Focus
          </>
        )}
      </Button>
    </>
  );
};
